import { render, staticRenderFns } from "./AddCandidateButton.vue?vue&type=template&id=ea9e6c1e&"
import script from "./AddCandidateButton.vue?vue&type=script&lang=js&"
export * from "./AddCandidateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports